module.exports = __webpack_public_path__ + "img/kuku.d966ea96.svg";